//@flow
import React from 'react';

type Props = {
  currentAmount:number,
  goalAmount:number,
};

function findWidth(props:Props) {
  let widthPercent = 100 * (props.currentAmount / props.goalAmount);
  if (widthPercent > 100) widthPercent = 100;
  return widthPercent;
}

export default function ProgressBar(props:Props) {
  const width = findWidth(props);
  const style = {width: width + '%'};
  return (
    <div className="progressbar-container">
      <div className="progressbar" style={style}/>
    </div>
  );
}
